import { useSelector } from 'react-redux';

import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { ISravniRating } from '../../interfaces/ratings';
import { IGlobalState } from '../index';

export enum RatingsTypes {
  Banks = 'banks',
  MFI = 'mfi',
  InsuranceCompanies = 'insuranceCompany',
}

export type IState = Record<RatingsTypes, ISravniRating[]>;

const initialState: IState = {
  banks: [],
  mfi: [],
  insuranceCompany: [],
};

const ratingSlice = createSlice({
  name: 'rating',
  initialState,
  reducers: {
    setRatings(state, { payload }: PayloadAction<Record<RatingsTypes, ISravniRating[]>>) {
      state[RatingsTypes.InsuranceCompanies] = payload[RatingsTypes.InsuranceCompanies];
      state[RatingsTypes.Banks] = payload[RatingsTypes.Banks];
      state[RatingsTypes.MFI] = payload[RatingsTypes.MFI];
    },
  },
});

const { reducer, actions } = ratingSlice;

export const { setRatings } = actions;
export default reducer;

export const banksRatingsSelector = (state: IGlobalState): ISravniRating[] => state.ratings.banks;
export const mfiRatingsSelector = (state: IGlobalState): ISravniRating[] => state.ratings.mfi;
export const insuranceCompaniesRatingsSelector = (state: IGlobalState): ISravniRating[] =>
  state.ratings.insuranceCompany;
export const ratingsSelector = (state: IGlobalState): IState => state.ratings;

export function useBanksRatings(): IState['banks'] {
  return useSelector<IGlobalState, IState['banks']>(banksRatingsSelector);
}

export function useMfiRatings(): IState['banks'] {
  return useSelector<IGlobalState, IState['mfi']>(mfiRatingsSelector);
}

export function useInsuranceCompaniesRatings(): IState['banks'] {
  return useSelector<IGlobalState, IState['insuranceCompany']>(insuranceCompaniesRatingsSelector);
}

export function useRatings(): IState {
  return useSelector<IGlobalState, IState>(ratingsSelector);
}
